import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ConfigContext } from '../../../contexts/ConfigContext';
import logo from '../../../assets/images/logo.png';

const NavBar = () => {
  const configContext = useContext(ConfigContext);
  const { headerBackColor } = configContext.state;

  // Mobile-first header - always fixed at top
  let headerClass = ['navbar', 'pcoded-header', 'mobile-header', 'navbar-expand-lg', 'headerpos-fixed', headerBackColor];

  return (
    <header className={headerClass.join(' ')}>
      <div className='m-header mobile-m-header'>
        <Link to='/dashboard' className='mobile-logo-link'>
          <img id='main-logo' src={logo} width='120' alt='' className='logo mobile-logo' />
        </Link>
        
        <div className='mobile-nav-right'>
          <Link
            to='/usuarios/editarPerfil'
            className='d-inline-flex align-items-center text-decoration-none'
            aria-label='Perfil'
            title='Perfil'
          >
            <i className='mdi mdi-account-circle f-28' />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default NavBar;
